module.exports = __webpack_public_path__ + "static/media/TimeMachineHologrid.1a32bef3.jpg";